import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleadsComponent } from './simple-icons-googleads.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleadsComponent ],
    exports:      [ SimpleIconsGoogleadsComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleadsModule {}
